import { useEffect, useRef, useState } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { CheckBox } from '../CheckBox';
import { useClickOutside } from '../../hooks/hooks';
import { BiSearch } from 'react-icons/bi';

interface Props {
  options: string[];
  values: string[];
  onChange: (newValue: string[]) => void;
  placeholder: string;
  selectAll?: boolean;
  isSearchable?: boolean;
}

export function MultiSelectDropDown({
  values = [],
  options: listoptions,
  onChange,
  placeholder,
  selectAll = false,
  isSearchable
}: Props) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<string[]>(listoptions || []);
  const dropDownRef = useRef(null);

  useEffect(() => {
    if (!open) {
      setOptions(listoptions);
    }
  }, [open]);

  // const checkName = (name: string, str: string) => {
  //   var pattern = str
  //     .split('')
  //     .map((x) => {
  //       return `(?=.*${x})`;
  //     })
  //     .join('');
  //   var regex = new RegExp(`${pattern}`, 'g');
  //   return name.match(regex);
  // };

  // const handleSearch = (value: string) => {
  //   if (!value) {
  //     setOptions(listoptions);
  //     return;
  //   }
  //   let temp = [...options];
  //   setOptions(
  //     temp.filter((item) => {
  //       return checkName(item, value) ? item : null;
  //     })
  //   );
  // };

  const handleSearch = (value: string) => {
    if (!value) {
      setOptions(listoptions);
      return;
    }
    let temp = [...options];
    setOptions(
      temp.filter((item) => {
        return item.toLowerCase().includes(value.toLowerCase()) ? item : null;
      })
    );
  };

  useClickOutside(dropDownRef, () => setOpen(false));

  return (
    <div className="w-full">
      <div ref={dropDownRef} className="relative w-full">
        <div
          tabIndex={0}
          onClick={() => setOpen(!open)}
          className="w-full flex items-center justify-between border-2 border-grey3 rounded-lg px-4 py-3 cursor-pointer bg-white  focus:border-neutralBlue1 focus:shadow-[0px_0px_0px_2px_rgb(182,207,255,0.25)]"
        >
          <p className={`text-sm font-normal ${values.length ? 'text-black' : 'text-gray-400'}`}>
            {values.length ? (
              <>
                {values.slice(0, 4).toString()}
                {values.length - 4 > 0 && (
                  <span className="text-xs p-1 bg-primary text-white mx-2 rounded-md">{`+${
                    values.length - 4
                  }more`}</span>
                )}
              </>
            ) : (
              placeholder
            )}
          </p>
          <MdKeyboardArrowDown className={`text-base transition-all ${open ? 'rotate-180' : 'rotate-0'}`} />
        </div>
        {open && (
          <div
            className={`absolute top-[110%] left-0 z-40 w-full max-h-64 transition-all  border-2 border-grey3  overflow-y-scroll list-scrollbar rounded-lg py-2 drop-shadow-sm bg-white`}
          >
            {isSearchable && (
              <div className={`w-full flex items-center justify-between py-2 px-2 cursor-pointer rounded-md`}>
                <div className="flex items-center justify-between w-full px-4 py-2 border border-neutralBlue1 rounded-md">
                  <input
                    type="text"
                    placeholder="Search"
                    className="w-full text-sm placeholder:text-black/40 placeholder:font-light outline-none focus:outline-none"
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  <BiSearch className="text-lg text-[#757D8A]" />
                </div>
              </div>
            )}
            {selectAll && (
              <div
                onClick={() => onChange(values.length === options.length ? [] : options)}
                className={`w-full flex items-center gap-4 py-2 px-4 cursor-pointer rounded-md ${
                  values.length === options.length ? 'bg-blue2' : 'bg-white'
                }`}
              >
                <CheckBox
                  defaultValue={values.length === options.length}
                  onChange={() => onChange(values.length === options.length ? [] : options)}
                />
                <p className="text-sm font-normal">Select All</p>
              </div>
            )}

            {options.map((option, index) => {
              return (
                <MultiSelectDropDownItem
                  key={index}
                  option={option}
                  checked={values.includes(option)}
                  onChange={(value, remove) => {
                    if (remove) {
                      let temp = values.filter((item) => item !== value);
                      onChange(temp);
                    } else {
                      onChange([...values, value]);
                    }
                  }}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

interface MultiSelectDropDownItemProps {
  onChange: (value: string, remove?: number) => void;
  option: string;
  checked: boolean;
}

function MultiSelectDropDownItem({ onChange, option, checked }: MultiSelectDropDownItemProps) {
  return (
    <div
      onClick={() => onChange(option, checked ? 1 : 0)}
      className={`w-full flex items-center gap-4 py-2 px-4 cursor-pointer rounded-md ${
        checked ? 'bg-neutralBlue2' : 'bg-white'
      }`}
    >
      <CheckBox defaultValue={checked} onChange={() => onChange(option, checked ? 1 : 0)} />
      <p className="text-sm font-normal capitalize">{option}</p>
    </div>
  );
}
